import { render, staticRenderFns } from "./AdministratorForm.vue?vue&type=template&id=6b89a7b6&"
import script from "./AdministratorForm.vue?vue&type=script&lang=js&"
export * from "./AdministratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports